import React from "react";
import { Link } from "react-router-dom";
import { DAY_LABELS, addDays, iso, overlapsDay, startOfWeek, toneClass } from "./helpers";

export const WeekView = ({ anchor, events, totalUnits, onPickDay }) => {
  const start = startOfWeek(anchor);
  const days = Array.from({ length: 7 }, (_, i) => addDays(start, i));
  const today = iso(new Date());

  return (
    <div className="-mx-1 overflow-x-auto pb-2" data-testid="calendar-week-view">
      <div className="flex min-w-[860px] gap-2 px-1">
        {days.map((d) => {
          const day = iso(d);
          const items = events.filter((e) => overlapsDay(e, day));
          const busy = items.reduce((a, e) => a + (e.qty || 1), 0);
          return (
            <div key={day} data-testid={`cal-week-day-${day}`}
              className={`flex-1 rounded-lg border bg-white p-2 ${day === today ? "border-lm-red/60" : "border-black/10"}`}>
              <button onClick={() => onPickDay(d)} className="flex w-full items-baseline justify-between text-left">
                <span className="text-xs font-semibold">{DAY_LABELS[(d.getDay() + 6) % 7]} {d.getDate()}</span>
                <span className="text-[10px] text-ink-soft">{busy}/{totalUnits}</span>
              </button>
              <div className="mt-2 space-y-1.5">
                {items.map((e) => {
                  const body = (
                    <>
                      <div className="truncate text-[11px] font-semibold leading-tight">{e.title}</div>
                      <div className="truncate text-[10px] opacity-75">{e.sub}</div>
                    </>
                  );
                  const cls = `block rounded border px-1.5 py-1 ${toneClass(e.tone)}`;
                  return e.link
                    ? <Link key={e.key} to={e.link} className={cls} data-testid={`cal-event-${e.key}`}>{body}</Link>
                    : <div key={e.key} className={cls} data-testid={`cal-event-${e.key}`}>{body}</div>;
                })}
                {items.length === 0 && <div className="text-[10px] text-ink-soft">Kosong</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
